module.exports = __webpack_public_path__ + "static/media/clear_text.0b2ccd6a.svg";